/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Meta_Defaultname1Inputs */

const id_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const ms_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const da_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const de_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const en_us2_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile`)
};

const es_es2_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil`)
};

const es_mx2_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil`)
};

const fil_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile`)
};

const fr_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const it_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilo`)
};

const hu_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const nl_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profiel`)
};

const no_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const pl_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const pt_br2_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil`)
};

const pt_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil`)
};

const ro_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const fi_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profiili`)
};

const sv_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const vi_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hồ sơ`)
};

const tr_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const cs_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const bg_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профил`)
};

const ru_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профиль`)
};

const uk_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профіль`)
};

const ar_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملف شخصي`)
};

const hi_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोफ़ाइल`)
};

const th_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โปรไฟล์`)
};

const ja_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロフィール`)
};

const zh_cn2_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`个人资料`)
};

const zh_hant1_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`個人資料`)
};

const ko_profile_meta_defaultname1 = /** @type {(inputs: Profile_Meta_Defaultname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프로필`)
};

/**
* | output |
* | --- |
* | "Profile" |
*
* @param {Profile_Meta_Defaultname1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_meta_defaultname1 = /** @type {((inputs?: Profile_Meta_Defaultname1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Meta_Defaultname1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_meta_defaultname1(inputs)
	if (locale === "ms") return ms_profile_meta_defaultname1(inputs)
	if (locale === "da") return da_profile_meta_defaultname1(inputs)
	if (locale === "de") return de_profile_meta_defaultname1(inputs)
	if (locale === "en-US") return en_us2_profile_meta_defaultname1(inputs)
	if (locale === "es-ES") return es_es2_profile_meta_defaultname1(inputs)
	if (locale === "es-MX") return es_mx2_profile_meta_defaultname1(inputs)
	if (locale === "fil") return fil_profile_meta_defaultname1(inputs)
	if (locale === "fr") return fr_profile_meta_defaultname1(inputs)
	if (locale === "it") return it_profile_meta_defaultname1(inputs)
	if (locale === "hu") return hu_profile_meta_defaultname1(inputs)
	if (locale === "nl") return nl_profile_meta_defaultname1(inputs)
	if (locale === "no") return no_profile_meta_defaultname1(inputs)
	if (locale === "pl") return pl_profile_meta_defaultname1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_meta_defaultname1(inputs)
	if (locale === "pt") return pt_profile_meta_defaultname1(inputs)
	if (locale === "ro") return ro_profile_meta_defaultname1(inputs)
	if (locale === "fi") return fi_profile_meta_defaultname1(inputs)
	if (locale === "sv") return sv_profile_meta_defaultname1(inputs)
	if (locale === "vi") return vi_profile_meta_defaultname1(inputs)
	if (locale === "tr") return tr_profile_meta_defaultname1(inputs)
	if (locale === "cs") return cs_profile_meta_defaultname1(inputs)
	if (locale === "bg") return bg_profile_meta_defaultname1(inputs)
	if (locale === "ru") return ru_profile_meta_defaultname1(inputs)
	if (locale === "uk") return uk_profile_meta_defaultname1(inputs)
	if (locale === "ar") return ar_profile_meta_defaultname1(inputs)
	if (locale === "hi") return hi_profile_meta_defaultname1(inputs)
	if (locale === "th") return th_profile_meta_defaultname1(inputs)
	if (locale === "ja") return ja_profile_meta_defaultname1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_meta_defaultname1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_meta_defaultname1(inputs)
	return ko_profile_meta_defaultname1(inputs)
});
export { profile_meta_defaultname1 as "profile.meta.defaultName" }